const printView  = () => import ('../components/print/printView.vue')
const projectMeetingP = () => import ('../components/projectMeetingP.vue')

export default [{
  path: '/printView',
  component: printView,
  children: [
    {
      path: 'projectMeetingP',
      component: projectMeetingP,
      name: 'projectMeetingP'
    }
  ]
  
}]
